import React, { Component, Fragment, useContext } from "react";
import {
    Modal,
    Button,
    Card,
    useAccordionToggle,
    AccordionContext,
    Accordion,
} from "react-bootstrap";
import _ from "lodash";
import Skeleton from "react-loading-skeleton";
import BaseFormComponent, { IBaseFormState } from "../../../../components/BaseFormComponent";
import textFormatService from "../../../../services/utility/textFormatService";
import ItemsTable, { filterFieldData } from "../../../../components/tableComponents/itemsTable";
import TableFilterPane from "../../../../components/tableComponents/tableFilterPane";
import { getCurrentUserSession } from "../../../../services/auth/authService";
// import TinRequestDetails from "../../../../loanAppraisal/appraisalDetailPages/TinRequestDetails";
// import { ContextAwareToggle } from "./documentCollection";
import { decodeToken } from "react-jwt";
import BaseListComponent, { IFilterData } from "../../../../components/BaseListComponent";
import loanProductService from "../../../../services/hybridAppraisal/loanProductService";
import loanRequestService from "../../../../services/hybridAppraisal/loanRequestService";
import { createFilterData, mapEntityList } from "../../../../services/utility/autoMapperService";
import TinValidationListModal from "./tinValidationList";
import ValidateAmount from "./validateAmountScreen";
import groupLoanRequestService from "../../../../services/hybridAppraisal/groupLoanRequestService";
import groupLoanRequestMembersService from "../../../../services/hybridAppraisal/groupLoanRequestMembersService";
import DetailItemsTable, { TableContext } from "../../../../components/tableComponents/detailItemsTable";

interface ValidateAmountModalFields { }

class ValidateAmountForm extends BaseFormComponent<ValidateAmountModalFields> { }

interface IValidateAmountModalProps {
    item: any;
    showPatchModal: boolean;
    togglePatchModal: any;
    members: any;
}

interface IValidateAmountModalState {
    item: any;
    updatingStatus: boolean;
    submitting: boolean;
    data: IFilterData;
    currentPage: number;
    pageSize: number;
    tableItems: any;
    fetching: boolean;
    fetchingDetail: boolean;
    totalSize: number;
    filterValueInput: filterFieldData;
    userRoles: any;
    systemProcess: any;
    applicableRules: any;
    appraisalActions: any;
    updateComponent: boolean;
    documentsToUpload: any;
    documentsToDelete: number[];
    canEditItem: boolean;
    updateAvailable: boolean;
    processResponse: any;
    specialConditions: any;
    ownUpdate: boolean;
    showValidateAccount: boolean;
    groupMembers: any;
    firstLoad: boolean;
}

class ValidateAmountList extends BaseListComponent<IValidateAmountModalState> { }

class ValidateAmountModal extends React.Component<
    IValidateAmountModalProps,
    IBaseFormState & IValidateAmountModalState
> {
    _isMounted: boolean;
    constructor(props: IValidateAmountModalProps) {
        super(props);
        this.state = {
            validated: false,
            submitting: false,
            errors: {},
            item: {},
            updatingStatus: false,
            data: createFilterData(["customerName", "loanType"]) as IFilterData,
            currentPage: 1,
            pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
            fetching: false,
            fetchingDetail: false,
            tableItems: [],
            totalSize: 0,
            filterValueInput: [
                { name: "customerName", fieldType: "text", value: "" },
                {
                    name: "loanType",
                    fieldType: "select",
                    options: ["Individual", "Corporate"],
                    value: "",
                }
            ],
            userRoles: [],
            systemProcess: [],
            applicableRules: [],
            appraisalActions: [],
            documentsToUpload: [],
            documentsToDelete: [],
            updateComponent: false,
            canEditItem: false,
            updateAvailable: false,
            specialConditions: [],
            processResponse: {
                actionId: 0,
                score: 0,
                response: ""
            },
            ownUpdate: false,
            showValidateAccount: false,
            groupMembers: {},
            firstLoad: true
        };
    }

    resetFields() {
        this.setState({
            validated: false,
            submitting: false
        });
    }

    handlePageChange = async (currentPage: number, pageSize: number, data?: IFilterData) => {
        currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
        pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
        if (this._isMounted) {
            this.setState({ fetching: true, ownUpdate: true });
        }

        // console.log(this.props.members)
        const eligibleMembers = _.isArray(this.props.members) ? this.props.members?.filter(x => x.memberStatus === "Eligible") : [];

        // console.log(eligibleMembers)
        const eligibleMembersPaginated: any = [];
        const totalLength = eligibleMembers.length;
        const initial = (currentPage - 1) * 10;
        for (let i = initial; i < initial + 10; i++) {
            eligibleMembersPaginated.push(eligibleMembers[i]);
            if (i === totalLength - 1) {
                break;
            }
        }

        try {
            if (this._isMounted) {
                this.setState({
                    tableItems: mapEntityList({
                        entityList: eligibleMembersPaginated,
                        properties: [
                            { oldName: "title", newName: "title" },
                            { oldName: "firstName", newName: "firstName" },
                            { oldName: "lastName", newName: "lastName" },
                            { oldName: "accountNumber", newName: "accountNumber" },
                            { oldName: "personalTIN", newName: "personalTIN" },
                            { oldName: "gender", newName: "gender" },
                            { oldName: "phoneNumber", newName: "phoneNumber" },
                            { oldName: "solidarityGroupName", newName: "solidarityGroupName" },
                            { oldName: "initialLoanAmount", newName: "approvedLoanAmount" },
                            { oldName: "loanAmount", newName: "updatedLoanAmount" },
                            // { oldName: "status", newName: "status" },
                        ],
                    }),
                    currentPage,
                    pageSize,
                    totalSize: eligibleMembers.length,
                    fetching: false,
                    ownUpdate: true,
                    firstLoad: false,
                });
            }
        } catch (ex) {
            if (ex.response && ex.response.status >= 400 && ex.response.status <= 499) {
                if (this._isMounted) {
                    this.setState({ fetching: false, ownUpdate: true, firstLoad: false });
                }
            } else {
                if (this._isMounted) {
                    this.setState({ fetching: false, ownUpdate: true, firstLoad: false });
                }
            }
        } finally {
            if (this._isMounted) {
                this.setState({ fetching: false, ownUpdate: true, firstLoad: false });
            }
        }
    };
    getFilteredItems = (data: IFilterData): IFilterData => {
        let filteredItems: IFilterData = {};
        Object.keys(data).forEach((key) => {
            if (data[key].item2 !== "") {
                filteredItems[key] = data[key];
            }
        });
        return filteredItems;
    };
    componentDidMount() {
        this._isMounted = true;
        this.handlePageChange(this.state.currentPage, this.state.pageSize);
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    fetchItemById = async (id) => {
        const groupLoanRequestMembers = await groupLoanRequestMembersService.retrieveById(id);
        const groupLoanRequestMembersDetails = groupLoanRequestMembers.data;
        this.setState({ groupMembers: groupLoanRequestMembersDetails, ownUpdate: true });

    }

    onToggleAmountModal = () => {
        this.setState({ showValidateAccount: !this.state.showValidateAccount, ownUpdate: true });
    };
    static getDerivedStateFromProps(nextProps: IValidateAmountModalProps, prevState) {
        if (prevState.ownUpdate) {
            return {
                ownUpdate: false,
            };
        }
        if (nextProps.item && nextProps.item.id != prevState.Item?.id) {
            return { item: nextProps.item, firstLoad: true };
        }
        return null;
    }



    handleOnExport = async (type: string) => { };

    render() {
        const { item, showPatchModal, togglePatchModal, members } = this.props;
        const {
            currentPage,
            pageSize,
            tableItems,
            totalSize,
            fetching,
            fetchingDetail,
            submitting,
            firstLoad,
            showValidateAccount
        } = this.state;

        if (_.isEmpty(item)) {
            return null;
        }
        const tableContext: TableContext = {
            name: "",
            primaryValue: "",
            successValue: "Successful",
            dangerValue: "Failed",

        };
        if (firstLoad) {
            this.handlePageChange(currentPage, pageSize);
        }
        return (
            <Modal
                size="xl"
                backdrop="static"
                show={showPatchModal}
                onHide={togglePatchModal}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5>
                            <i className="fas fa-edit fa-sm cyan-text mr-3" />
                            Individual Personal Details
                        </h5>
                    </Modal.Title>
                </Modal.Header>
                <ValidateAmountForm
                    initialValues={{}}
                    FormComponent={({
                        fields: { },
                        onChange,
                        onReloadFields,
                        onHandleSubmit,
                    }) => (
                        <React.Fragment>
                            <Modal.Body>
                                <div className="card">
                                    <div className="card-header clear-fix">
                                        {_.isEmpty(item) ? (
                                            <Skeleton width={200} />
                                        ) : (
                                            <h6
                                                className="card-title float-left"
                                                style={{ marginBottom: "0px" }}
                                            >
                                                <b>Approved Loan</b>
                                            </h6>
                                        )}
                                    </div>
                                    <div className="card">
                                        <Accordion defaultActiveKey="0">
                                            <div>
                                                <Card>
                                                    {/* <ContextAwareToggle
                                                        eventKey={`0`}
                                                        level={""}
                                                    ></ContextAwareToggle> */}
                                                    <Accordion.Collapse eventKey={`0`}>
                                                        <Card.Body>
                                                            <ValidateAmountList
                                                                pageChangeHandler={this.handlePageChange}
                                                                fetchingDetail={fetchingDetail}
                                                                initialValues={{
                                                                    data: this.state.data,
                                                                    fetching: false,
                                                                    showDetailsModal: false,
                                                                    showEditModal: false,
                                                                    showTableFilterModal: false,
                                                                    showTrailModal: false,
                                                                    tableItems: [],
                                                                    filterValueInput: this.state.filterValueInput,
                                                                    item: {},
                                                                }}
                                                                tableItems={tableItems}
                                                                item={members}
                                                                DetailsModal={({
                                                                    item,
                                                                    onToggleDetailsModal,
                                                                    onToggleEditModal,
                                                                    showDetailsModal,
                                                                    showEditModal
                                                                }) => (
                                                                    <Fragment>

                                                                        <ValidateAmount
                                                                            values={this.state.groupMembers}
                                                                            item={item}
                                                                            showAmountModal={showValidateAccount}
                                                                            toggleAmountModal={this.onToggleAmountModal}
                                                                        />
                                                                    </Fragment>

                                                                )}
                                                                ListPayLoad={({
                                                                    data,
                                                                    showTableFilterModal,
                                                                    tableItems,
                                                                    onToggleDetailsModal,
                                                                    onToggleTableFilterModal,
                                                                    onHandleFilterItemRemove,
                                                                    filterValueInput,
                                                                }) => (
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <DetailItemsTable
                                                                                title="Approved Members"
                                                                                item={tableItems}
                                                                                handleOnPageChange={
                                                                                    this.handlePageChange
                                                                                }
                                                                                content={tableItems}
                                                                                contentCount={totalSize}
                                                                                page={currentPage}
                                                                                onViewDetails={(item: any) => {
                                                                                    this.fetchItemById(item.id)
                                                                                    this.onToggleAmountModal();
                                                                                }}
                                                                                fetching={fetching}
                                                                                timeColumn={["dateCreated"]}
                                                                                amountColumn={["approvedLoanAmount", "updatedLoanAmount"]}
                                                                                contextualColumn={tableContext}
                                                                                emptyTitle="No Approved Members"
                                                                                hasDetailModal={true}
                                                                            />
                                                                            {/* <div className="card no-b">
                                                                                <div className="card-body">
                                                                                    <div className="card-title">
                                                                                        <div id="list-filters" className="ml-4 mr-4">
                                                                                            <TableFilterPane
                                                                                                filteredItems={this.getFilteredItems(data)}
                                                                                                handleFilterRemove={onHandleFilterItemRemove}
                                                                                            />
                                                                                        </div>
                                                                                        <div id="list-table">
                                                                                            <ItemsTable
                                                                                                data={data}
                                                                                                items={tableItems}
                                                                                                filterValueInput={filterValueInput}
                                                                                                showTableFiltermodal={false}
                                                                                                toggleTableFiltermodal={onToggleTableFilterModal}
                                                                                                name="Approved Members"
                                                                                                currentPage={currentPage}
                                                                                                pageSize={1}
                                                                                                totalSize={totalSize}
                                                                                                fetching={fetching}
                                                                                                handlePageChange={this.handlePageChange}
                                                                                                onViewDetails={(item: any) => {
                                                                                                    this.fetchItemById(item.id)
                                                                                                    this.onToggleAmountModal();
                                                                                                }}
                                                                                                handleOnExport={this.handleOnExport}
                                                                                                timeColumn={["dateCreated"]}
                                                                                                amountColumn={["approvedLoanAmount", "updatedLoanAmount"]}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div> */}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            ></ValidateAmountList>

                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </div>
                                        </Accordion>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={() => togglePatchModal(false, {}, {})}
                                    disabled={submitting}
                                >
                                    <i className="fas fa-times mr-3" />
                                    Close
                                </Button>

                            </Modal.Footer>

                        </React.Fragment>
                    )}
                ></ValidateAmountForm>
            </Modal>
        );
    }
}

export default ValidateAmountModal;
